<template>
  <div class="details" v-if="list!=null">
    <h1>
      
      <span v-if="list.CardCondition" class="tag tag_condition el-icon-warning-outline" @click="$emit('setframe')">{{categoryI18n(list.CardCondition)}}</span>
      <span v-if="list.CardSize" class="tag tag_size">{{categoryI18n(list.CardSize)}}</span>
      {{list.Title}}
    </h1>
    <div class="">
      <div class="line price_d">
        <div class="price_l">
          <template v-if="list.Status<0">
            <div class="price_d_p" v-if="list.ByWay==2">{{$t('colon.winBid')}}</div>
            <div class="price_d_p" v-if="list.ByWay==1">{{$t('colon.price')}}</div>
          </template>
          <template v-if="list.Status==0">
            <div class="price_d_p" v-if="list.ByWay==2">{{$t('colon.StartingBid')}}</div>
            <div class="price_d_p" v-if="list.ByWay==1">{{$t('colon.price')}}</div>
          </template>
          <h5>{{areaSymbol}} {{formatPrice(list.USD_Price)}}</h5>
        </div>

        <div class="detail_btn" v-if="userInfo!=null&&isWatchlist" @mousemove="setwatch(isWatchlist,1)" @mouseout="setwatch(isWatchlist,0)">
          <div class="collec" :class="isWatchlist?'on':''" @click="setAttention">{{watchName}}</div>
        </div>
        <!-- <div>Approxiatmately <strong>RMB {{list.Price}}</strong></div> -->
      </div>
      <div class="bids_d">
        <div class="bids_box bids_top" v-if="list.ByWay==2">
          <router-link class="icon_auction auction_h" :to="{path:'/mycardhobby/bidhistory/'+list.ID}"  v-if="userInfo!=null&&list.AuctionCount>0">{{list.AuctionCount}}
            {{list.AuctionCount != 1?$t('base.bids'):$t('base.bid')}}</router-link>
        </div>
        <!-- <div class="bids_box bids_top" v-if="list.ByWay==1">
          <router-link class="" v-if="list.Bargain==1&&list.PriceCount!=3"
            :to="{path:'/mycardhobby/offerhistory/'+list.ID}">{{list.AuctionCount}} offers</router-link>
        </div> -->
      </div>
      <div class="ship_return line ended" v-if="list.Status<0">
        <div class="price_d_p">{{$t('colon.ended')}}</div>
        <div>
          {{setTime(list.EffectiveTime)}}
        </div>
      </div>
      <div class="ship_return line ended" v-if="list.Status==0">
        {{$t('base.Itwillbelisted',{time:setTime(list.LastOnTime)})}}
      </div>
      <template v-if="list.IsValut!=1">
        <div class="ship_return line" style="position: relative;" v-if="userInfo!=null">
          <div class="price_d_p">{{$t('colon.shipping')}}</div>
          <div>
            <div class="price_d_see" >
              <strong  v-if="domesticCustom">
              <span v-if="domesticCustom.Status==1">{{$t('base.freeShipping')}}</span>
              <span :class="list.MemberSource!='US'?'business':''" v-if="domesticCustom.Status==2">{{list.MemberSource!='US'?$t('alert.PaidOnDelivery'):$t('base.payOnDelivery')}}</span> 
              <span v-if="domesticCustom.Status==3">{{areaSymbol}} {{domesticCustom.USD_Price}}</span>
              </strong>
              <span class="hengxian"></span>
              <span class="see see_color" @click="domVisible=true" v-if="list.OrderType!=1&&list.MemberSource=='US'">{{$t('base.seeDetails')}}</span>
            </div>
            <!-- <span class="text_blue isUS see" @click="IsUS">{{$t('base.ifSellerNoUSA')}}</span> -->
            <!-- <div><strong>$4.00</strong> (approx. RMB 25.52) Standard Shipping<span class="see see_color" @click="SeeDetail(1)">See details</span></div> -->
          </div>
        </div>
      </template>
      <div class="text_gray" v-if="list.DomesticCustom&&list.DomesticCustom.length>0&&userInfo!=null">{{$t('colon.located')}} {{otherList.address}}</div>
      <!-- <div class="ship_return">
            <div>Payments:</div>
            <div class="Payments">12312</div>
          </div> -->
      <div class="ship_return Premium" v-if="ServiceFee>0">

        <div class="price_d_p">{{$t('colon.buyerPremium')}}</div>
        <div>
          <span>{{areaSymbol}} {{ServiceFee}} {{SPercent}}</span>
          <!-- <span class="del" v-if="Discount>0">$ {{Discount}} {{DPercent}}</span> -->
        </div>
        <!-- <span class="Promotion">{{$t('base.promotion')}}</span> -->
        <div class="hengxian"></div>
        <span class="text_blue see see_details" @click="IsPremium(2)">{{$t('base.seeDetails')}}</span>
      </div>
      <div class="ship_return Premium" v-if="userInfo!=null&&TaxServiceFee!=null&&list.MemberSource=='US'">
        <div class="price_d_p">{{$t('colon.stateTax')}}</div>

        <!-- <div class="tax_price">
          <span>{{$t('base.accordToShipAddress')}}</span>
          <span class="tax_price_Promotion">
            <span class="Promotion">{{$t('base.promotion')}}</span>{{TaxSPercent}} {{$t('base.inPromotionPeriod')}}
          </span>
        </div> -->
        <div>
          <span>{{areaSymbol}} {{TaxServiceFee}} {{TaxSPercent}}</span>
          <!-- <span class="del" v-if="TaxDiscount>0">$ {{TaxDiscount}} {{TaxDPercent}}</span> -->
        </div>
        <!-- <span class="Promotion">Promotion</span> -->
        <div class="hengxian"></div>
        <span class="text_blue see see_details" @click="IsPremium(3)">{{$t('base.seeDetails')}}</span>
      </div>

        <div class="text_oversea" v-if="userInfo!=null&&(list.MemberSource!=userInfo.MemberSource&&userInfo.MemberSource!='MO')">{{$t('alert.willBeOversea')}}</div>
      <!-- <div class="ship_return">
            <div>Returns:</div>
            <div>
              <div>Seller does not accept returns. lf the item you received doesn't match thelisting description, your purchase may be eligible for eBay Money Back Guarantee if the return request is made within 3 days from delivery. l</div>
            </div>
          </div> -->
    </div>
    <domestic :domVisible="domVisible" :list="list" v-if="domVisible" @getDialog="getDialog" />
  </div>
</template>
<script>
import qs from 'qs'
import { countDown, getInfo, getTime, setUTC, priceExchange,numMulti,isUserDomest,isNumber} from "@/api/public";
import Domestic from "@/components/dialog/domestic";
export default {
  name: 'auction',
  components: { Domestic },
  data() {
    return {
      agencyProvice: null,
      areaSymbol: this.$store.state.areaSymbol,
      domesticCustom:null,
      input: "",
      place_input: "",
      domVisible: false,
      place_input: "",
      timer: "",
      nowData: new Date().getTime(),
      isWatchlist: null,
      watchName: this.$t('base.addToWatch'),
      userInfo: null,
      ServiceFee: null,
      Discount: null,
      ServiceFee: null,
      Discount: null,
      SPercent: null,
      DPercent: null,
      TaxServiceFee: null,
      TaxDiscount: null,
      TaxSPercent: null,
      TaxDPercent: null,

    }
  },
  watch: {
    'list': {
      handler(obj) {
        this.domesticCustom=isUserDomest(this.userInfo,this.list.DomesticCustom,this.agencyProvice)
        this.GetServiceFee();
        //this.GetTaxPrice();
        this.isWatchlist = obj.IsAttention != 0 ? true : false;
        if (this.isWatchlist) {
          this.watchName = this.$t('base.watching')
        }
      }
    }
  },
  props: {
    list: {},
    otherList:{},
    type: String,
    ByWay: Number,
  },
  // filters: {
  //   setTime(val) {
  //     return getTime(val, -8, '', 'cn')
  //   }
  // },
  mounted() {
    // console.log('list.IsAttention', this.list)
    if (this.userInfo != null) {
      this.GetAgency(this.list)
    }
    this.GetServiceFee();
  },
  created() {
    this.cardTimer();
    this.isWatchlist = this.list.IsAttention != 0 ? true : false;
    if (this.isWatchlist) {
      this.watchName = this.$t('base.watching')
    }
    this.userInfo = getInfo()
    this.domesticCustom=isUserDomest(this.userInfo,this.list.DomesticCustom,this.list.MemberSource)
  },
  methods: {
    // 价格展示：兼容带千分位的字符串(如 "1,234.56")，避免 Number() 得到 NaN 后 toLocaleString() 出错
    formatPrice(val) {
      let num = isNumber(val == null ? 0 : val)
      return isNaN(num) ? '' : Number(num).toLocaleString()
    },
    categoryI18n(obj) {
      var value = obj.replace(/\s*/g, "")
      if (value.indexOf('/') > 0) {
        value = value.replace('/', "")
      }
      var i18nValue=this.$t('categoryKey.' + value)
      if(i18nValue.indexOf('categoryKey.')>-1){
        i18nValue=obj
      }
      return i18nValue
      //console.log(value,'value')
    },
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setShipsFrom(obj){
      var address=obj.Address
      if(obj.MemberSource=='CN'){
        address='China'
      }
      if(obj.MemberSource=='HK'){
        address='Hong Kong'
      }
      if(obj.MemberSource=='MO'){
        address='Macao'
      }
      if(obj.MemberSource=='TW'){
        address='China'
      }
      return address
    },
    GetAgency(obj) {
      let that = this
      if (obj.MemberSource != that.userInfo.MemberSource) {
        let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, memberSource: obj.MemberSource }
        this.$get(this.$interface.GetAgency, data).then(res => {
          if (res.result != 0) {
            that.agencyProvice=res.data
            that.domesticCustom = isUserDomest(that.userInfo, that.list.DomesticCustom, that.list.MemberSource, res.data)
          }
        })
      } else {
        this.domesticCustom = isUserDomest(that.userInfo, that.list.DomesticCustom, that.list.MemberSource, null)
      }
    },
    // 竞拍数字判断
    IsNumber(e){
      if(this.place_input.length>=9){

          this.place_input=this.place_input.slice(0,9)
        // if(this.place_input.indexOf('.')>0){

        // }else{
        //   this.place_input=this.place_input.slice(0,9)
        // }
      //console.log(this.place_input,'that.place_input1231')
      }
    },
    // 用户来源对应服务费列表
    GetServiceList() {
      let that = this;
      let SellMemberSource = that.list.MemberSource
      let BuyMemberSource = that.userInfo.MemberSource
      let data = { buyerSource: BuyMemberSource, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
      that.$get(that.$interface.GetServiceList, data).then(res => {
        if (res.result != 0) {
          var result = res.data
          result.map(item => {
            var PayType='Stripe'
            if(BuyMemberSource=="MO"){
              PayType='MPay'
            }
            if (item.BuyerSource == BuyMemberSource && item.SellerSource == SellMemberSource && item.PayType == PayType) {
              that.SPercent = item.Fee != 0 ? '(' + (numMulti(item.Fee,100)) + '%)': '(0%)'
              that.$root.$emit("SPercent", (numMulti(item.Fee,100)));
              that.DPercent = item.Discount != 0 ? '(' + (numMulti(item.Discount,100)) + '%)' : '(0%)'
            }
          })
        }
      })
    },
    // 税
    GetTaxPrice() {
      let that = this;
      if (this.userInfo != null) {
        if (that.userInfo.Count>0&&that.userInfo.State!='') {
          let data = { commodityId: this.list.ID, StateName: that.userInfo.State, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
          that.$get(that.$interface.GetTaxPrice, data).then(res => {
            if (res.result != 0) {
              that.TaxServiceFee = priceExchange(res.data.TaxPrice, 'USD')
              that.TaxDiscount = priceExchange(res.data.Discount, 'USD')
              that.TaxSPercent = res.data.TaxPercent != 0 ? '(' + (numMulti(res.data.TaxPercent,100)) + '%)' : '(0%)'
              that.TaxDPercent = res.data.DiscountPercent != 0 ? '(' + (numMulti(res.data.DiscountPercent,100)) + '%)' : '(0%)'
            }
          })
        }
      }
    },
    // 服务费
    GetServiceFee() {
      let that = this;
      if (that.list && that.userInfo != null && that.list.OrderType != 1) {
        this.domesticCustom=isUserDomest(this.userInfo,this.list.DomesticCustom,this.agencyProvice)
        that.GetTaxPrice();
        that.GetServiceList()
        //var DomesticPrice = this.list.DomesticCustom[0].Price || 0
        var DomesticPrice = this.domesticCustom.Price || 0
        let data = { memberId: this.userInfo.MappingUserId, commodityId: this.list.ID, postageMoney: DomesticPrice, isGuareent: 6, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
        that.$get(that.$interface.GetServiceFeeByCommodityID, data).then(res => {
          if (res.result != 0) {
            that.ServiceFee = priceExchange(res.data.ServiceFee, 'USD')
            that.Discount = priceExchange(res.data.Discount, 'USD')
          }
        })
      }
    },
    // SeeDetail(val){
    //   this.$parent.BidsTabs(val)
    // },
    getDialog(val) {
      this.domVisible = val
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    //事件转换格式
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let i = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      //console.log(this.recommend[0].time)
      return countDown(i, this.nowData)
    },
    IsUS() {
      this.$emit('isus')
    },
    //关注类型
    setwatch(val, type) {
      let that = this
      let isWatch = val
      if (isWatch) {
        that.watchName = that.$t('base.watching')
        if (type) {
          that.watchName = that.$t('base.unWatch')
        }
      } else {
        that.watchName = that.$t('base.addToWatch')
      }
    },
    // 关注商品
    setAttention() {
      let that = this;
      if (that.userInfo != null) {
        let data = { 'commodityid': that.list.ID, 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
        this.$post(that.$interface.SetAttention, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            that.isWatchlist = !that.isWatchlist
            that.watchName = that.$t('base.addToWatch')
            if (that.isWatchlist) {
              that.watchName = 'Watching'
            }
          }
        })
      }
    },
    IsPremium(val) {
      this.$emit('ispremium',val)
    }

  }
}

</script>
<style scoped>
@import "../../../static/css/carddetails.css";

/deep/ .el-dialog__body {
  padding: 0;
}

.shipping_box {
  padding: 12px 40px 0;
}

.shipping_title {
  height: 18px;
  font-size: 16px;
}

.shipping_title_t {
  margin: 24px 0 0;
}

.shipping_cost {
  height: 18px;
  color: #f0ad4e;
  border: #f0ad4e 1px solid;
  border-radius: 3px;
  padding: 0 4px;
  margin: 0 0 0 8px;
}

.locations,
.cost_l span {
  height: 16px;
  margin: 16px 0 12px;
}

.color_aoao {
  height: 16px;
}

.address {
  display: block;
  margin: 12px 0 0 0;
}

.international_s {
  margin: 12px 0;
}

.bids_top {
  margin-top: 16px;
}

.shipping_f,
.ship_return,
.cost_l,
.price_d,
.price_l {
  display: flex;
}

.price_l {
  align-items: center;
}

.cost_l,
.price_d {
  justify-content: space-between;
}

.price_d_p {
  width: 80px;
  margin-right: 16px;
}

/* .ship_return > div:last-child {
  width: 80%;
} */

.ship_return > div:last-child div {
  /* margin-bottom: 10px; */
 /* margin: 10px 0;*/
}

.ship_return .text_gray {
  font-size: 12px;
}

.ship_return {
  /* border-bottom: 1px solid #f0f0f0; */
  /* margin-bottom: 10px; */
  margin: auto 0px;
}

.detail_btn {
  width: 180px;
  margin: 0;
}

.ship_last_line2 {
  border-bottom: none;
}

/* .see {
  border-left: 1px solid;
  margin-left: 10px;
  padding-left: 10px;
} */

.see:hover,
.isUS:hover {
  text-decoration: underline;
}

h5 {
  font-size: 24px;
  display: inline-block;
}

h5 .bids_box {
  font-size: 14px;
  font-weight: normal;
  margin-left: 25px;
  display: inline-block;
}

.Payments {
  height: 16px;
  display: block;
  background: url(../../../static/images/paypal2.png) no-repeat;
  background-size: 16.5%;
}

.see {
  cursor: pointer;
}

/* .ship_return div {
  margin: auto 16px auto 0;
  width: 80px;
} */
.details h1 {
  margin-bottom: 16px;
}

.ended {
  padding-bottom: 16px;
}

.text_gray {
  padding-top: 8px;
  margin-left: 96px;
}

.bids_box {
  margin-bottom: 16px;
}

.bids_d {
  display: inline-block;
}

.collec {
  color: #5f6dae;
}

</style>



// WEBPACK FOOTER //
// src/components/detail/finish.vue